module.exports = __webpack_public_path__ + "img/health2.647c698a.png";